var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradeStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4159_314",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4615 12.1852L20.1329 9.49012L17.3963 0.579274C17.2909 0.235637 16.9706 0 16.609 0C16.2475 0 15.9271 0.235637 15.8217 0.579274L13.086 9.49012L5.75652 12.1852C5.43287 12.3047 5.21875 12.6099 5.21875 12.9527C5.21875 13.2947 5.43287 13.6015 5.75652 13.7201L13.0818 16.4144L15.8193 25.5969C15.923 25.9438 16.2442 26.1819 16.609 26.1819C16.973 26.1819 17.295 25.9438 17.3988 25.5961L20.1362 16.4136L27.4624 13.7193C27.7844 13.6015 27.9993 13.2955 27.9993 12.9527C27.9993 12.6107 27.7844 12.3047 27.4615 12.1852Z",
    fill: "url(#paint0_linear_4159_314)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9917 21.1859L9.08603 20.4855L8.34485 17.7855C8.24768 17.4288 7.92238 17.1817 7.55097 17.1817C7.17955 17.1817 6.85426 17.4288 6.75626 17.7847L6.01508 20.4847L4.11025 21.1851C3.7866 21.3037 3.57248 21.6105 3.57248 21.9525C3.57248 22.2945 3.7866 22.6013 4.11025 22.72L6.0052 23.4179L6.75214 26.3814C6.84438 26.7446 7.17297 26.9999 7.55097 26.9999C7.92897 26.9999 8.25756 26.7446 8.34979 26.3805L9.09674 23.4171L10.9917 22.7192C11.3153 22.6013 11.5295 22.2945 11.5295 21.9525C11.5295 21.6105 11.3153 21.3037 10.9917 21.1859ZM7.4192 3.46156L5.47237 2.74565L4.75096 0.810641C4.63155 0.489095 4.32354 0.276367 3.97848 0.276367C3.63425 0.276367 3.32625 0.489095 3.20601 0.810641L2.48542 2.74565L0.537767 3.46156C0.214118 3.58101 0 3.88701 0 4.22902C0 4.57102 0.214118 4.87784 0.537767 4.99647L2.48542 5.71238L3.20601 7.64739C3.32625 7.96894 3.63425 8.18166 3.97848 8.18166C4.32272 8.18166 4.63072 7.96894 4.75096 7.64739L5.47155 5.71238L7.4192 4.99647C7.74285 4.87702 7.95697 4.57102 7.95697 4.22902C7.95697 3.88701 7.74285 3.58101 7.4192 3.46156Z",
    fill: "#FFCC4D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4159_314)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -3.5166,
    width: 28,
    height: 33.1989,
    fill: "url(#paint1_linear_4159_314)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4159_314",
    x1: 16.609,
    y1: 0,
    x2: 16.609,
    y2: 26.1819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99671F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4159_314",
    x1: 14,
    y1: -3.5166,
    x2: 14,
    y2: 29.6823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED9C63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeStar);
export default __webpack_public_path__ + "static/media/Upgrade Star.91d9bd3087690d34691f089fca5a09b6.svg";
export { ForwardRef as ReactComponent };